import LazyLoad from '../vendors/lazyload.min.js';

function lazyImages() {
    let lazyLoadInstance = new LazyLoad({
        elements_selector: '.lazy',
    });
}

export default lazyImages;